import { render, staticRenderFns } from "./MeasureLabelInput.vue?vue&type=template&id=09ff3858"
import script from "./MeasureLabelInput.vue?vue&type=script&lang=js"
export * from "./MeasureLabelInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports